// extracted by mini-css-extract-plugin
export default {"banner":"AuthMessage_banner__gHYre","error":"AuthMessage_error__yiYZW","success":"AuthMessage_success__tQTId"};